"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RoundCurrency = void 0;
require("core-js/modules/es.regexp.to-string.js");
const RoundCurrency = (amount, description) => {
  // Accepts 0 amount
  if (!amount && amount !== 0) {
    /* eslint-disable-next-line no-console */
    console.warn('Could not round currency for amount:', amount, description);
    return amount;
  }
  const currencyAmount = amount.toString();
  const posDecimalPt = currencyAmount.lastIndexOf('.');
  const hasDollar = currencyAmount.indexOf('$') === 0;
  if (posDecimalPt === -1) {
    return "".concat(hasDollar ? '' : '$').concat(Number(currencyAmount).toLocaleString());
  }
  return "".concat(hasDollar ? '' : '$').concat(Number(currencyAmount.substring(0, posDecimalPt)).toLocaleString());
};
exports.RoundCurrency = RoundCurrency;
var _default = exports.default = {
  RoundCurrency
};